module.exports = __webpack_public_path__ + "696ec550bdb018a8f3c897b512432eec.MP3";